import React from 'react';

import { GeographyContext, useGeographyContextLogic } from '@/hooks/useGeographyContext';

interface GeographyContextProviderProps {
  children: React.ReactNode;
}

export function GeographyContextProvider({ children }: GeographyContextProviderProps) {
  const value = useGeographyContextLogic();
  return <GeographyContext.Provider value={value}>{children}</GeographyContext.Provider>;
}
